import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck, ArrowRight } from "lucide-react";
import { adminApi, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AcceptInvite({ token }) {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { refreshAdmin } = useAuth();
  useEffect(() => { adminApi.inviteInfo(token).then(setInfo).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message)); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      const d = await adminApi.acceptInvite(token, pw);
      refreshAdmin?.();
      toast.success(`Welcome, ${d.user.name}`);
      navigate("/admin");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };
  const inputCls = "w-full rounded-2xl border border-white/25 bg-black/15 px-4 py-3.5 text-[15px] font-medium text-white placeholder:text-white/70 outline-none focus:border-[#EBBAD1]";

  return (
    <div className="w-full max-w-md animate-fade-up rounded-[28px] bg-black/15 p-6 text-white" data-testid="accept-invite-card">
      <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-full bg-[#EBBAD1] text-[#28282E]"><ShieldCheck className="h-7 w-7" /></div>
      <h1 className="text-center font-serif text-3xl font-black">Set your password</h1>
      {error ? <p className="mt-4 rounded-2xl bg-red-500/20 p-4 text-center text-sm font-semibold" data-testid="invite-error">{error}</p>
        : !info ? <div className="grid place-items-center py-8"><Loader2 className="h-6 w-6 animate-spin" /></div> : (
        <form onSubmit={submit} className="mt-4 space-y-3">
          <p className="text-center text-sm text-white/85">Hi <b>{info.name}</b> — set a new password for <b>{info.email}</b> (role: <b className="uppercase">{info.role}</b>).</p>
          <input data-testid="invite-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Choose a password or PIN (min 6)" required minLength={6} className={inputCls} />
          <input data-testid="invite-password2-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Repeat it" required className={inputCls} />
          <button type="submit" data-testid="invite-submit-button" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-[#28282E] py-3.5 text-base font-bold text-white disabled:opacity-70">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : null} Activate & sign in <ArrowRight className="h-4 w-4" />
          </button>
        </form>
      )}
      <button type="button" onClick={() => navigate("/login?role=admin")} className="mt-4 w-full text-center text-xs text-white/70 underline">Back to sign in</button>
    </div>
  );
}
